import CommonValidation from '../../../../utils/common.validation';

class Validation {
  static formValidate = (type, value) => {
    switch (type) {
      case 'driverPickupTime':
        return CommonValidation.nonRequiredTime(value);
      default:
        return '';
    }
  };
}

export default Validation;
